export default __webpack_public_path__ + "static/media/arrow-icon.033c09ef.gif";